export const GIS_SEARCH = 'gis_search';
export const CALLS = 'calls';
export const AXON = 'axon';
